import { useSelector } from "react-redux";
import MainHome from "./homeUser/MainHome";

const Home = () => {
  const user = useSelector((state) => state.auth.user);
  return (
    <>
      <MainHome role={user.role} name={user.name} />
    </>
  );
};

export default Home;
